import * as React from "react";
import type { SVGProps } from "react";
const SvgPersonSnowboarding = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.688 6.45a2.78 2.78 0 0 0 4.742-1.96v-.71A2.79 2.79 0 0 0 14.65 1a2.79 2.79 0 0 0-2.78 2.78v.71a2.78 2.78 0 0 0 .818 1.96Zm1.41-3.222a.78.78 0 0 1 1.332.552v.71a.769.769 0 0 1-.78.77.77.77 0 0 1-.78-.77v-.71a.78.78 0 0 1 .229-.552Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M9.6 8.25h2.25a1 1 0 0 0 1-.95 1 1 0 0 0-1-1H9.76l-2.1-.7a1 1 0 0 0-.63 1.9l2.25.75c.106.015.214.015.32 0Z"
    />
    <path
      fill="currentColor"
      d="m11.69 13.53-2.381 3.572-2.278-2.284L9.23 11.84l2.09 1a1 1 0 0 0 1.401-1.207 1 1 0 0 0-.501-.583L9.37 9.63a1 1 0 0 0-1.25.3l-2.517 3.457L3.66 11.44a2.39 2.39 0 0 1-.67-1.32 1 1 0 0 0-1.97.34 4.28 4.28 0 0 0 1.23 2.39l8.67 8.7c.7.677 1.566 1.16 2.51 1.4h.23a1 1 0 0 0 .97-.74 1 1 0 0 0-.74-1.2 3.73 3.73 0 0 1-1.55-.87l-1.575-1.579 2.105-3.211a3.19 3.19 0 0 0 2.57-.27 3.19 3.19 0 0 0 1.63-2.8V10l2.06.47a1 1 0 0 0 .93-.27l2.25-2.25a1 1 0 0 0-.325-1.639 1 1 0 0 0-1.095.219l-1.86 1.86-2.73-.62a1 1 0 0 0-1.23.97v3.54a1.2 1.2 0 0 1-.62 1.06 1.21 1.21 0 0 1-1.23 0l-.18-.12a1 1 0 0 0-1.35.31Z"
    />
  </svg>
);
export default SvgPersonSnowboarding;
